import { cx } from './cx';

export type ChipTone = 'neutral' | 'brand' | 'success' | 'warning' | 'danger';

/** Só aceitamos hex de 6 dígitos. A cor vem do banco, escolhida pelo usuário:
 *  sem validação, `background: ${cor}` aceita qualquer string e vira injeção
 *  de CSS. E como a cor só pinta um ponto de 8px, um valor claro degrada para
 *  invisível — nunca para texto ilegível. */
const HEX = /^#[0-9a-fA-F]{6}$/;

/**
 * `kind` separa duas informações que estavam com a MESMA forma na primeira
 * versão desta vitrine: etiqueta escolhida pelo usuário e status do sistema.
 * Lado a lado numa tabela, "Financeiro" e "Resolvida" eram indistinguíveis
 * como categorias — só o texto dizia qual era qual.
 *
 *   status  pílula preenchida, tom semântico. Vocabulário fechado do sistema.
 *   tag     retângulo com borda e ponto de cor. Vocabulário aberto do cliente.
 */
export function Chip({
  children, tone = 'neutral', color, kind = 'status',
}: {
  children: string;
  tone?: ChipTone;
  /** Cor arbitrária vinda do banco (tag). Vira ponto decorativo, nunca texto. */
  color?: string | null;
  kind?: 'status' | 'tag';
}) {
  const dot = color && HEX.test(color) ? color : null;
  return (
    <span className={cx('chip', `chip--${kind}`, tone !== 'neutral' && `chip--${tone}`)}>
      {dot && <span className="chip__dot" style={{ background: dot }} aria-hidden="true" />}
      {children}
    </span>
  );
}
